export const SALES_BASE = '/portal/sales';

export const SALES_TABS = [
  { id: 'dashboard', label: 'All', path: '', matchPaths: ['', 'all'], emoji: '📋' },
  { id: 'resources', label: 'Materials', path: 'resources', emoji: '📂' },
  { id: 'analytics', label: 'Analytics', path: 'analytics', emoji: '📊' },
  { id: 'design-pricing', label: 'Design Pricing', path: 'design-pricing', emoji: '💲' },
  { id: 'build-payments', label: 'Build Payments', path: 'build-payment-calculator', emoji: '🧮' },
  { id: 'goals', label: 'Goals', path: 'goals', emoji: '🎯', hiddenInNav: true },
  { id: 'proposals', label: 'Proposals', path: 'proposals', hiddenInNav: true },
];

export const SALES_NAV_TABS = SALES_TABS.filter((tab) => !tab.hiddenInNav);
export const DEFAULT_SALES_TAB = 'dashboard';

export function getActiveSalesTabId(pathname) {
  if (!pathname?.startsWith(SALES_BASE)) return DEFAULT_SALES_TAB;
  const remainder = pathname.slice(SALES_BASE.length).replace(/^\//, '');
  if (!remainder) return DEFAULT_SALES_TAB;
  const firstSegment = remainder.split('/')[0];
  for (const tab of SALES_TABS) {
    const paths = tab.matchPaths || [tab.path];
    if (paths.some((p) => firstSegment === p || remainder.startsWith(`${p}/`))) return tab.id;
  }
  return DEFAULT_SALES_TAB;
}

export function getSalesTabHref(tab) {
  if (tab.path === '' || tab.id === 'dashboard') return SALES_BASE;
  return `${SALES_BASE}/${tab.path}`;
}
